module.exports = __webpack_public_path__ + "img/noImage.081652d1.png";